export default __webpack_public_path__ + "static/media/phone.307615ee.png";